
import { ReactNode, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp } from "lucide-react";

interface SectionProps {
  id?: string;
  title?: string;
  expanded?: boolean;
  onToggle?: () => void;
  children: ReactNode;
}

export const Section = ({ id, title, expanded = true, onToggle = () => {}, children }: SectionProps) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
    onToggle();
  };
  
  // If no title is provided, just render the children without the section header
  if (!title) {
    return <>{children}</>;
  }
  
  return (
    <Card className="w-full overflow-hidden mb-4" id={id}>
      <div className="flex items-center justify-between px-6 py-4 cursor-pointer bg-gray-50" onClick={handleToggle}>
        <h3 className="text-lg font-semibold">{title}</h3>
        <Button variant="ghost" size="sm" onClick={e => { e.stopPropagation(); handleToggle(); }}>
          {isExpanded ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
        </Button>
      </div>
      {isExpanded && <CardContent className="p-6">{children}</CardContent>}
    </Card>
  );
};
